import { Fragment, useEffect, useRef, useState } from "react";
import axios from "axios";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
// import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";

import "./notes_feature_content_component.scss";
import { Document, Page, pdfjs } from "react-pdf/dist/esm/entry.webpack";
import images from "../../../../../utilities/images/images";
import ViewSDKClient from "../../../../../custom_utilities/AdobeSDK/ViewSDKClient";
// import demo from "./demo.pdf"

import { EmbedPDF } from "@simplepdf/react-embed-pdf";




const NotesFeatureContentComponent = (props) => {
  let { history, notesData, tokenType, token } = props;

  const [numPages, setNumPages] = useState(null);
  const [pdfData, setPdfData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPdfData();
  }, []);

  


  const handleRedirect = () => {
    history.goBack();
  };

  console.log('pdfData', pdfData);

  const getPdfData = async () => {
    try {
      const response = await axios.get(
        `https://learning.motion.ac.in/motioneducation/api/notes?file=${
          notesData.notes.match(/\/([^/]+)$/)[1]
        }&id=${notesData.notes_id}`,
        {
          headers: {
            Authorization: `${tokenType} ${token}`,
          },
          // responseType: "arraybuffer", // Specify response type as arraybuffer
        }
      );

      if (response.status === 200) {
        setPdfData(response.data);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching PDF:", error);
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <div className="notesFeatureContentComponent_wrapper">
        <div className="container">
          <div className="notesFeatureContentComponent_inner_wrapper ">
            <div className="sec_1_wrapper">
              <div className="sec_1_inner_wrapper">
                <div className="btn_wrapper">
                  <button onClick={() => handleRedirect()}>
                    <img src={images.user_activity_1} alt="Back" />
                  </button>
                </div>
                <div className="text_content_wrapper">
                  <p className="text_content">{notesData.notes_title}</p>
                </div>
              </div>
            </div>
            <div className="notes_wrapper">
              {loading ? (
                <p></p>
              ) : (
                <div id="pdf-div" className="notes_inner_wrapper">
                    {/* <Document
                    file={{ data: pdfData }}
                    onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                      onContextMenu={(e) => e.preventDefault()}
                      renderMode="svg"
                      // scale={1.5}
                  >
                    {Array.from(new Array(numPages), (el, index) => (
                      <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                    ))}
                  </Document>
                     */}
                  <iframe className="iframer" id='iframerr' src={`${notesData.notes}#toolbar=0`}  frameborder="0"
                    />

                    {/* <iframe className="iframer" id='iframerr' src={`${notesData.notes}`}  frameborder="0"
                    /> */}

 {/* <EmbedPDF
   mode="inline"
  style={{ width: 900, height: 800 }}
  documentURL={notesData.notes}
 /> */}

                    
                    <>
                      {/* <EmbedPDF 
  mode="inline"
  style={{ width: 900, height: 800 }}
  documentArrayBuffer={pdfData}
/> */}


      </>
                      
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default NotesFeatureContentComponent;


// // import React, { useEffect } from 'react';
// // import WebViewer from '@pdftron/webviewer';

// // const PDFViewer = () => {
// //   useEffect(() => {
// //     WebViewer({
// //       path: '/webviewer/lib',
// //       initialDoc: '/path/to/your/document.pdf',
// //     }, document.getElementById('viewer'))
// //       .then(instance => {
// //         // Access the instance object here
// //       });
// //   }, []);

// //   return (
// //     <div id="viewer" style={{ width: '100%', height: '100vh' }}></div>
// //   );
// // };

// // export default PDFViewer;


// // import { EmbedPDF } from "@simplepdf/react-embed-pdf";



// // const NotesFeatureContentComponent = () => {
  

// //   return (
// //     <>

// //  <EmbedPDF
// //   mode="inline"
// //   style={{ width: 900, height: 800 }}
// //   documentURL="https://cdn.simplepdf.eu/simple-pdf/assets/sample.pdf"
// // />

// //  <EmbedPDF
// //   mode="inline"
// //   style={{ width: 900, height: 800 }}
// //       />
// //       </>
// //   )

// // }


// // export default  NotesFeatureContentComponent;



// import { Fragment, useEffect, useState } from "react";
// import axios from "axios";
// import { Document, Page, pdfjs } from "react-pdf";
// import images from "../../../../../utilities/images/images";

// const NotesFeatureContentComponent = (props) => {
//   let { history, notesData, tokenType, token } = props;

//   const [pdfData, setPdfData] = useState(null);
//   const [numPages, setNumPages] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [scale, setScale] = useState(1); // Initial scale

//   useEffect(() => {
//     getPdfData();
//   }, []);

//   const handleRedirect = () => {
//     history.goBack();
//   };

//   const getPdfData = async () => {
//     try {
//       const response = await axios.get(
//         `https://learning.motion.ac.in/motioneducation/api/notes?file=${
//           notesData.notes.match(/\/([^/]+)$/)[1]
//         }&id=${notesData.notes_id}`,
//         {
//           headers: {
//             Authorization: `${tokenType} ${token}`,
//           },
//           responseType: "arraybuffer", // Specify response type as arraybuffer
//         }
//       );

//       if (response.status === 200) {
//         setPdfData(response.data);
//         setLoading(false);
//       }
//     } catch (error) {
//       console.error("Error fetching PDF:", error);
//       setLoading(false);
//     }
//   };

//   const zoomIn = () => {
//     setScale(scale + 0.2); // Increase scale
//   };

//   const zoomOut = () => {
//     setScale(scale - 0.2); // Decrease scale
//   };

//   return (
//     <Fragment>
//       <div className="notesFeatureContentComponent_wrapper">
//         <div className="container">
//           <div className="notesFeatureContentComponent_inner_wrapper ">
//             <div className="sec_1_wrapper">
//               <div className="sec_1_inner_wrapper">
//                 <div className="btn_wrapper">
//                   <button onClick={() => handleRedirect()}>
//                     <img src={images.user_activity_1} alt="Back" />
//                   </button>
//                 </div>
//                 <div className="text_content_wrapper">
//                   <p className="text_content">{notesData.notes_title}</p>
//                 </div>
//               </div>
//             </div>
//             <div className="notes_wrapper">
//               {loading ? (
//                 <p>Loading...</p>
//               ) : (
//                 <div className="notes_inner_wrapper">
//                   <div className="zoom_controls">
//                     <button onClick={zoomIn}>Zoom In</button>
//                     <button onClick={zoomOut}>Zoom Out</button>
//                   </div>
//                   <Document
//                     file={{ data: pdfData }}
//                     onLoadSuccess={({ numPages }) => setNumPages(numPages)}
//                   >
//                     {Array.from(new Array(numPages), (el, index) => (
//                       <Page key={`page_${index + 1}`} pageNumber={index + 1} scale={scale} />
//                     ))}
//                   </Document>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </Fragment>
//   );
// };

// export default NotesFeatureContentComponent;
